import { defineComponent as _defineComponent } from 'vue'
import { dir } from '@@/bits/current_dir'
import { __ } from '@@/bits/intl'
import ImageThumbnail from '@@/library/v4/components/ImageThumbnail.vue'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from '@@/library/v4/components/OzContainedButton.vue'
import { storeToRefs } from 'pinia'
import { useDarkModeStore } from '@@/pinia/dark_mode'
import { useWindowSizeStore } from '@@/pinia/window_size'


export default /*#__PURE__*/_defineComponent({
  __name: 'LandsideCallToAction',
  setup(__props) {

const { isDarkMode } = storeToRefs(useDarkModeStore())
const { isSmallerThanTabletLandscape } = storeToRefs(useWindowSizeStore())

const footerIllustrationDarkUrl = 'https://padlet.net/how-it-works/v1/illustration_call_to_action_dark.webp'
const footerIllustrationLightUrl = 'https://padlet.net/how-it-works/v1/illustration_call_to_action_light.webp'

const callToActionOriginalIllustrationWidth = 10386
const callToActionOriginalIllustrationHeight = 992
const callToActionGroupHeight = 248

return { __sfc: true,isDarkMode, isSmallerThanTabletLandscape, footerIllustrationDarkUrl, footerIllustrationLightUrl, callToActionOriginalIllustrationWidth, callToActionOriginalIllustrationHeight, callToActionGroupHeight, dir, __, ImageThumbnail, OzContainedButton, OzContainedButtonColorScheme, OzContainedButtonSizePreset }
}

})